import React from "react";
import CustomModal from "../General/customModal";
import Button from "../button";
import CenteredDots from "../General/centeredDots";
import FormResponseMessage from "../formResponseMessage";

const DeleteAnswerModal = (props) => {
    const {isOpen, onClose, onConfirm, isLoading, errorMessage} = props;

    return (
        <CustomModal
            isOpen={isOpen}
            content={<div className={"form-horizontal"}>
                <div className={"form-group"}>
                    <div className={"col-sm-12"}>
                        <label>Are you sure you want to delete the selected item?</label>
                    </div>
                </div>
                <div className={"form-group"}>
                   <div className={"col-sm-12"}>
                       <Button
                           clickHandler={onConfirm} wrapper="btn-wrapper"
                           btnType="button" btnStyle={'btn btn-primary btn-xs sharp yellow'}
                           label="Yes"
                       />
                       <Button
                           clickHandler={onClose} wrapper="btn-wrapper"
                           btnType="button" btnStyle={'btn btn-primary btn-xs sharp white'}
                           label="Cancel"
                       />
                   </div>
                </div>
                {
                    errorMessage && (
                        <FormResponseMessage
                            Message={errorMessage}
                            CenterWrapper={'col-sm-12'}
                            MessageStyle="formResponseMessage-reject"
                        />
                    )
                }
                {
                   isLoading && (
                       <div className={"form-group"}>
                           <div className={'col-sm-12'}>
                               <CenteredDots/>
                           </div>
                       </div>
                    )
                }
            </div>}
            handleClose={onClose}
        />
    )
};

export default DeleteAnswerModal;